module.exports = "/_next/static/images/843ddd879d295790091b15872ce3d339-kit-icon.png.webp";